import { render, staticRenderFns } from "./ElevenLabs.vue?vue&type=template&id=bbb14f38&"
import script from "./ElevenLabs.vue?vue&type=script&lang=js&"
export * from "./ElevenLabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports